<template functional>
  <pre>{{props}}</pre>
</template>

<script>
    export default {
        name: "DebugCell"
    }
</script>

<style scoped>

</style>
